/**
 * ProductService - Refactorizado para usar Clean Architecture
 * 
 * Este servicio mantiene compatibilidad con la API anterior mientras
 * internamente usa el repositorio y modelos de dominio.
 * 
 * MIGRACIÓN: Los DTOs e interfaces se han movido a:
 * - DTOs: core/infrastructure/dto/product.dto.ts
 * - Modelos: core/domain/models/product.model.ts
 * 
 * Para nuevos desarrollos, usar directamente ProductRepository o crear casos de uso.
 */

import { Injectable, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ProductRepository } from '@domain/repositories/product.repository';
import { PRODUCT_REPOSITORY_TOKEN } from '@domain/repositories/product.repository.token';
import { ProductOption } from '@domain/models/product.model';

// Re-exportar tipo para compatibilidad (usar desde domain/models)
export type { ProductOption } from '@domain/models/product.model';

@Injectable({ providedIn: 'root' })
export class ProductService {
  private repository = inject<ProductRepository>(PRODUCT_REPOSITORY_TOKEN);
  private productsCache: ProductOption[] | null = null;

  getProductOptions(): Observable<ProductOption[]> {
    // Si ya tenemos productos en caché, devolverlos directamente
    if (this.productsCache) {
      return of(this.productsCache);
    }

    // Si no hay caché, llamar al repositorio y guardar en caché
    return this.repository.getProductOptions().pipe(
      tap(products => {
        this.productsCache = products;
      })
    );
  }

  // Método para limpiar el caché si es necesario
  clearCache(): void {
    this.productsCache = null;
  }
}
